import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Conditional class names with Tailwind conflict resolution. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * A fresh idempotency key for one distinct spend attempt.
 *
 * The API's own contract (RevealRequest.idempotency_key): "a retried call with the SAME
 * key against the SAME quote replays the stored result rather than burning credits twice
 * — generate a fresh one per distinct reveal attempt, not per retry". So the key is
 * minted ONCE when a quote is approved and reused for every retry of that approval; it is
 * never regenerated inside a retry loop.
 */
export function newIdempotencyKey(prefix = "radar-web"): string {
  const random =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
  return `${prefix}-${random}`;
}
